<template>
    <div class="rich-text-editor" :style="{ border: '1px solid #ccc', zIndex: 100 }">
        <Toolbar
            :style="{ borderBottom: '1px solid #ccc' }"
            :editor="editor"
            :defaultConfig="toolbarConfig"
            :mode="mode"
        />
        <Editor
            :style="{ height: height + 'px', overflowY: 'hidden' }"
            v-model="html"
            :defaultConfig="editorConfig"
            :mode="mode"
            @onCreated="onCreated"
        />
    </div>
</template>

<script>
import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
import { getDefaultToolbarConfig, getDefaultEditorConfig, createToolbarConfig, createEditorConfig } from '@/utils/editorConfig'

export default {
    name: 'RichTextEditor',
    components: {
        Editor,
        Toolbar
    },
    props: {
        // 编辑器内容
        value: {
            type: String,
            default: ''
        },
        // 编辑器高度
        height: {
            type: Number,
            default: 300
        },
        // 占位符文本
        placeholder: {
            type: String,
            default: '请输入内容...'
        },
        // 工具栏类型：'default' | 'simple' | 'basic'
        toolbarType: {
            type: String,
            default: 'default'
        },
        // 自定义工具栏配置
        customToolbarKeys: {
            type: Array,
            default: null
        },
        // 编辑器模式
        mode: {
            type: String,
            default: 'default'
        },
        // 是否禁用
        disabled: {
            type: Boolean,
            default: false
        },
        // 上传配置
        uploadConfig: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            editor: null,
            html: this.value
        }
    },
    computed: {
        // 工具栏配置
        toolbarConfig() {
            if (this.customToolbarKeys) {
                return createToolbarConfig(this.toolbarType, this.customToolbarKeys)
            }
            return createToolbarConfig(this.toolbarType)
        },
        // 编辑器配置
        editorConfig() {
            const config = {
                placeholder: this.placeholder,
                readOnly: this.disabled,
                ...this.uploadConfig
            }
            return createEditorConfig(config)
        }
    },
    watch: {
        value(newVal) {
            this.html = newVal
        },
        html(newVal) {
            this.$emit('input', newVal)
        },
        disabled(newVal) {
            if (this.editor) {
                this.editor.disable(newVal)
            }
        }
    },
    beforeDestroy() {
        const editor = this.editor
        if (editor == null) return
        editor.destroy() 
    },
    methods: {
        // 富文本编辑器创建完成
        onCreated(editor) {
            this.editor = Object.seal(editor) 
        },
        // 清空内容
        clear() {
            if (this.editor) {
                this.editor.clear()
            }
        },
        // 获取内容
        getContent() {
            return this.html
        },
        // 设置内容
        setContent(content) {
            this.html = content
        },
        // 插入内容
        insertContent(content) {
            if (this.editor) {
                this.editor.insertText(content)
            }
        },
        // 获取纯文本内容
        getText() {
            if (this.editor) {
                return this.editor.getText()
            }
            return ''
        }
    }
}
</script>

<style lang="less" scoped>
.rich-text-editor {
    border-radius: 4px;
    
    :deep(.w-e-text-container) {
        border-radius: 0 0 4px 4px;
    }
    
    :deep(.w-e-toolbar) {
        border-radius: 4px 4px 0 0;
    }
}
</style>
